import React, { useState, useContext } from 'react'
import DeleteItemModal from './DeleteItemModal'
import { Button } from 'react-bootstrap'
import { itemType } from '../types'
import { boolean } from 'yup'
import UserContext from '../contexts/UserContext'


export default function DeleteItem({ item, canWrite }) {
  const [showDeleteItem, setShowDeleteItem] = useState(false)
  const { roles } = useContext(UserContext)

  function canDeleteItem() {
    // cannot delete item with children
    if (item.hasChildren || canWrite == false) {
      return false
    }

    // cannot delete Date Release item
    if (item.identifiers?.find(d => d.type.toUpperCase() == "DOI")?.key?.includes('10.5066')){
      return false
    }
    
    // sys admin can delete items with doi, even local
    if (roles.includes('ScienceBase_SystemAdmin')) {
      return true
    }
  }

  return (
    <div>
      <Button disabled={canDeleteItem() == false} style={{ marginLeft: '9px' }} variant="secondary" size="md" onClick={(e) => {
        e.preventDefault()
        setShowDeleteItem(true)
      }}>Delete Item</Button>
      <DeleteItemModal
        show={showDeleteItem}
        onHide={() => {
          setShowDeleteItem(false)
        }}
        itemId={item.id}
        parentItemId={item.parentId} />
    </div>
  )
}

DeleteItem.propTypes = {
  item: itemType,
  canWrite: boolean
}
